import { render, staticRenderFns } from "./SuperRecommended.vue?vue&type=template&id=3796945a&scoped=true&"
import script from "./SuperRecommended.vue?vue&type=script&lang=js&"
export * from "./SuperRecommended.vue?vue&type=script&lang=js&"
import style0 from "./SuperRecommended.vue?vue&type=style&index=0&id=3796945a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3796945a",
  null
  
)

export default component.exports